/**
 * delivvr.ts - Delivvr (Project Management) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export const delivvrModule = {
  id: 'business-delivvr',
  name: 'Project Management',
  icon: '📊',
  category: 'modules',
  order: 50,
  
  packageInfo: {
    name: '@opcentral/delivvr',
    version: '0.2.0',
    displayVersion: '0.2.0',
    description: 'Universal project management system for OpCentral',
    status: 'in-progress',
    implementationProgress: 60,
    dependencies: {
      '@opcentral/core': '*',
      '@opcentral/actr': '*',
      '@opcentral/notifyr': '*'
    },
    keywords: ['project', 'management', 'tasks', 'workflow'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    defaultView: {
      type: 'select',
      label: 'Default View',
      description: 'Default project view',
      defaultValue: 'board',
      options: [
        { label: 'Board', value: 'board' },
        { label: 'List', value: 'list' },
        { label: 'Timeline', value: 'timeline' },
        { label: 'Calendar', value: 'calendar' }
      ]
    },
    
    enableNotifications: {
      type: 'boolean',
      label: 'Task Notifications',
      description: 'Notify on task updates',
      defaultValue: true
    },
    
    autoAssign: {
      type: 'boolean',
      label: 'Auto-Assign Tasks',
      description: 'Automatically assign tasks based on rules',
      defaultValue: false
    }
  }
};

export default delivvrModule;
